import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import * as auth from "../../store/ducks/auth.duck";
import { useHistory, useLocation } from "react-router-dom";
import { LayoutSplashScreen } from "../../../_metronic";

const PreResetPassword = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    const searchParams = location.search;

    localStorage.clear();
    dispatch(auth.actions.logout());

    setTimeout(() => {
      history.replace(`/password/reset${searchParams}`);
    }, 200);
  }, [dispatch, history, location]);

  return <LayoutSplashScreen />;
};

export default PreResetPassword;
